// local url
// export const url = "http://localhost:4066"

// live url
//
export const url = "https://www.aahilya.com/api/";
// F6ECF5
